import { render, staticRenderFns } from "./invoicelisttable.vue?vue&type=template&id=8524b48c&scoped=true&"
import script from "./invoicelisttable.vue?vue&type=script&lang=js&"
export * from "./invoicelisttable.vue?vue&type=script&lang=js&"
import style0 from "./invoicelisttable.vue?vue&type=style&index=0&id=8524b48c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8524b48c",
  null
  
)

export default component.exports